import { Controller } from "@hotwired/stimulus"

// Ripetitore dei campi del form builder.
//
// Stesso schema del controller booking-questions: il template porta il
// segnaposto NEW_RECORD nei name, sostituito con un indice crescente al
// momento dell'inserimento. L'indice parte dal numero di righe già presenti e
// non viene mai riusato, così rimuovere una riga in mezzo non fa collidere i
// name delle righe successive (il modello ricompatta comunque l'array).
export default class extends Controller {
  static targets = ["list", "row", "template"]

  connect() {
    this.counter = this.rowTargets.length
  }

  addRow() {
    const markup = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, this.counter++)
    this.listTarget.insertAdjacentHTML("beforeend", markup)
  }

  removeRow(event) {
    event.currentTarget.closest("[data-form-fields-target='row']").remove()
  }
}
